

<template>
  <div   class="card card-body card-procces-id-main-box mb-5 border-0">
    <div class="row d-flex justify-content-start">
      <h3 style="font-size: 1.2vw !important;">مشخصات فعاليت‏‌های فرآيند</h3>
    </div>
    <form class="needs-validation mt-2 mb-3" novalidate>
      <div class="row">
        <div class="col-lg-2-6 mb-3 ms-n-1">
          <label class="form-label">عنوان فعالیت</label>
          <input v-model="title" class="form-control" type="text" name="" required>
        </div>
        <div class="col-lg-2-6 mb-3 ms-n-1">
          <label class="form-label">سمت متولی  </label>
          <input v-model="inserterName" class="form-control" type="text" style="width: 12.3vw;" readonly
                 placeholder="انتخاب کنید" @click.prevent="showListInserter">
        </div>
        <div class="col-lg-2-5 mb-3 ms-n-1">
          <label class="form-label">نام متولی</label>
          <input v-model="inserterNameTwo" class="form-control" type="text" style="width: 12.3vw;" readonly
                 placeholder="انتخاب کنید" @click.prevent="showListInserterTwo">
        </div>
        <div class="col-lg-2-5 mb-3 ms-n-1">
          <label class="form-label">آیا مکانیزه است؟  </label>
          <select v-model="mechanic" class="form-select">
            <option value="" disabled selected>انتخاب کنید</option>
            <option value="1">بله</option>
            <option value="0">خیر</option>
          </select>
        </div>
        <div class="col-lg-2 mb-3 ms-n-1">
          <label class="form-label">متوسط زمان اجرا</label>
          <input v-model="time" class="form-control" type="number" name="" required>
        </div>
        <div class="col-lg-2 mb-3 ms-n-1">
          <label class="form-label">تواتر اجرا</label>
          <input v-model="frequency" class="form-control" type="text" name="" required>
        </div>
        <div class="col-lg-2 mb-3 ms-n-1">
          <label class="form-label"> محاسبات  </label>
          <input :value="time*frequency"  class="form-control" disabled type="text" name="" required>
        </div>


        <div class="col-lg-2 mb-3 ms-n-1">
          <label class="form-label">پيش نياز</label>
          <input v-model="prerequisite" class="form-control" type="text" name="" required>
        </div>

        <div class="col-lg-1 mb-3" style="margin-right: 2.7vw">
          <button v-show="!editModal" @click.prevent="saveItem" class="btn btn-primary btn-submit-1" type="submit"
                  style="margin-top: 1.9vw; font-size: 2vw;">
            <span style="transform: translateY(.2vw)">+</span>
          </button>
          <button v-show="editModal" @click.prevent="update(item_id)" class="btn btn-primary btn-submit-1" type="submit"
                  style="margin-top: 1.9vw; font-size: 1vw;">
            <span style="">ویرایش</span>
          </button>
        </div>
      </div>
      <hr>
    </form>
    <div class="table-responsive">
      <center v-show="!all_items.length">
        مشخصات فعالیت های فرآیند وجود ندارد
      </center>
      <table v-if="all_items.length" class="table table-striped" style="width: 70vw;">
        <thead>
        <tr>
          <th>ردیف</th>
          <th style="width: 15vw;">عنوان فعالیت</th>
          <th>سمت متولی</th>
          <th>نام متولی</th>
          <th style="width: 3vw ;">آیا مکانیزه است؟</th>
          <th style="width: 7vw;">متوسط زمان اجرا(دقیقه)</th>
          <th style="width: 7vw;">تواتر اجرا</th>
          <th style="width: 7vw;">محاسبات  </th>
          <th >پیش نیاز  </th>

          <th style="width: 6vw;">عملیات</th>
        </tr>
        </thead>
        <tbody>

        <tr v-for="(item,index) in all_items" :id="`item_${item.id}`">
          <td scope="row">{{index+1}}</td>

          <td>{{item.title}}</td>
          <td>
            <span @click="allUsersMethod(item.id)" style="color: #0d6efd; cursor: pointer;">مشاهده</span>
          </td>
          <td>
            <span @click="allUsersMethodTwo(item.id)" style="color: #0d6efd; cursor: pointer;">مشاهده</span>
          </td>
          <td style="width: 4vw;">{{item.mechanic}}</td>
          <td style="width: 4vw;">{{item.frequency}}</td>
          <td style="width: 4vw;">{{item.average_time}}</td>
          <td>{{!(parseInt(item.average_time) * parseInt(item.frequency)) ? 0 : parseInt(item.average_time) * parseInt(item.frequency)}}</td>
          <td>{{item.prerequisite??'--'}}</td>
          <td>
            <div class="d-flex justify-content-evenly w-100">
              <p style="width: 2vw;" @click.prevent="deleteModalMethod(item.id)" href="#"><img class="table-delete-img mx-2" src="/img/delete.f9fc94bc.svg" alt="delete"> </p>
              <a  style="width: 2vw; transform: translateX(-0.2vw)" @click.prevent="edit(item.id)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>

            </div>
          </td>
        </tr>

        </tbody>
      </table>
    </div>
  </div>
<!-- ************************************** -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter"
       style="z-index: 999999999999999999999999999999999999999999999; top: 28%;">
    <div>
      <p>مسئول اجرا    </p>
      <p @click="select_inserter=!select_inserter">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <div style="overflow-y:scroll; width: 100%; height: 10vw;">

      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td scope="row"><input :id="`item1_${item.id}`" v-model="inserterId" type="checkbox"   :value="item['id']"></td>
          <td><label :for="`item1_${item.id}`">{{ item['id'] }}</label></td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      </div>
      <button @click="select_inserterMethod">تایید</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 35%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(item_id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; top: 28%;">
    <div>
      <p>   خطا  </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{errorMessage}}



      <button @click="error=!error">بازگشت</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="allUserModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 38%;">
    <div>
      <p>   متولی  </p>
      <p @click="allUserModal=!allUserModal">❌</p>
    </div>
    <div>
      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th>ردیف</th>
          <th>پست سازمانی</th>
          <th>نام و نام خانوادگی</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in allUser" :key="item.id">
          <td>{{ index+1 }}</td>
          <td>{{ item.organizationposts.name }}</td>
          <td>{{ item.organizationposts.curator.fullname }}</td>
        </tr>

        </tbody>
      </table>



      <button @click="allUserModal=!allUserModal">بازگشت</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserterTwo"
       style="z-index: 999999999999999999999999999999999999999999999; top: 28%;">
    <div>
      <p>نام متولی      </p>
      <p @click="select_inserterTwo=!select_inserterTwo">❌</p>
    </div>
    <div>
      <input v-model="search_inserterTwo" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in all_inserterTwo" :key="item.id">
          <td scope="row"><input :id="`item2_${item.id}`"  v-model="inserterIdTwo" type="checkbox" name="parent" :value="item['id']"></td>
          <td><label :for="`item2_${item.id}`">{{ item['id'] }}</label></td>
          <td><label :for="`item2_${item.id}`">{{ item['name'] }}</label></td>

        </tr>

        </tbody>
      </table>
      <button @click="select_inserterMethodTwo">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter"
       style="z-index: 999999999999999999999999999999999999999999999; top: 28%;">
    <div>
      <p>سمت متولی      </p>
      <p @click="select_inserter=!select_inserter">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td scope="row"><input :id="`item1_${item.id}`" v-model="inserterId" type="checkbox" name="parent" :value="item['id']"></td>
          <td><label :for="`item3_${item.id}`">{{ item['id'] }}</label></td>
          <td><label :for="`item3_${item.id}`">{{ item['name'] }}</label></td>
        </tr>

        </tbody>
      </table>
      <button @click="select_inserterMethod">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allUserModalTwo"
       style="z-index: 999999999999999999999999999999999999999999999; top: 38%;">
    <div>
      <p>   متولی  </p>
      <p @click="allUserModalTwo=!allUserModalTwo">❌</p>
    </div>
    <div>
      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th>ردیف</th>
          <th>نام و نام خانوادگی  </th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in allUserTwo" :key="item.id">
          <td>{{ index+1 }}</td>
          <td>{{ item.user.fullname }}</td>

        </tr>

        </tbody>
      </table>



      <button @click="allUserModalTwo=!allUserModalTwo">بازگشت</button>
    </div>
  </div>
</template>
<script>
import {mapMutations, mapState} from "vuex";
import {all} from "core-js/internals/document-all";
import Edit from "@/components/Icons/Edit.vue";
import Reset from "@/components/Icons/Reset.vue";
import Save from "@/components/Icons/Save.vue";
import PlusIcon from "@/components/Icons/PlusIcon.vue";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  components: {PlusIcon, Save, Reset, Edit},
  props: ['id_route', 'type'],
  data() {
    return {
      all_items: [],
      allUser: [],
      allUserModal: false,
      allUserModalTwo: false,
      all_inserter: [],
      select_inserter: false,
      select_inserterTwo: false,
      inserterNameTwo: '',
      deleteModal: false,
      editModal: false,
      search_inserter: '',
      inserterId: [],
      all_inserterTwo: [],
      search_inserterTwo: '',
      title: '',
      owner: '',
      mechanic: '',
      inserterName: '',
      type: '',
      time: '',
      frequency: '',
      prerequisite: '',
      item_id: '',
      supplier: 1,
      error: false,
      errorMessage: false,
      is_references: false,
      references: '',
      text: '',
      inserterIdTwo: [],
      allUserTwo: [],


    }
  },


  methods: {
    resetData(){
      this.inserterId.length=0
      this.inserterIdTwo.length=0
      this.title=''
      this.inserterName=''
      this.inserterNameTwo=''
      this.title= ''
      this.time= ''
      this.frequency= ''
      this.prerequisite= ''
      this.inserterId.length=0
      this.owner=''
      this.text= ''
      this.references= ''
      this.is_references= ''
      this.mechanic= ''
      this.PIdTwo= ''
      this.PId= ''
      this.showListprocessModel= ''
      this.showListprocessModelTwo= ''
      this.id_clone = ''


    },
    select_inserterMethodTwo() {

      // اطمینان حاصل کنید inserterId یک آرایه از اعداد یا رشته‌ها است
      if (Array.isArray(this.inserterIdTwo)) {
        // متغیر برای نگهداری نتیجه
        let resultString = '';

        // بررسی هر عنصر در inserterId
        this.inserterIdTwo.forEach((id, index) => {
          // یافتن متن متناظر با id
          const matchingElement = this.all_inserterTwo.find(ele => ele.id === id);

          // اگر یک متن متناظر پیدا شود، اضافه کردن به نتیجه
          if (matchingElement) {
            resultString += matchingElement.name;

            // اگر عنصر آخری نبود، خط تست را اضافه کنید
            if (index < this.inserterIdTwo.length - 1) {
              resultString += ' - ';
            }
          }
        });

        // نتیجه را در inserterName قرار دهید
        this.inserterNameTwo = resultString;

        // تغییر وضعیت select_inserter به false
        this.select_inserterTwo = false;
      }
      this.select_inserterTwo = false



    },
    allUsersMethodTwo(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/show_users/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.allUserTwo.length=0
              response.all.forEach((item)=>{
                this.allUserTwo.push(item)
              })
              this.allUserModalTwo = true
            }




          })
          .catch();
    },
    allUsersMethod(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/show_or/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
           if (response.all){
             this.allUser.length=0
             response.all.forEach((item)=>{
               this.allUser.push(item)
             })
           this.allUserModal = true
           }




          })
          .catch();
    },
    allUsersMethodForedit(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/show_or/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
           if (response.all){
             this.allUser.length=0
             response.all.forEach((item)=>{
               this.allUser.push(item)
             })
           }




          })
          .catch();
    },
    deleteModalMethod(id){
      this.item_id=id
      this.deleteModal=true
    },
    deleteItemForm(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.deleteModal=false


          })
          .catch();
    },
    edit(id){
      this.item_id=id
      this.editModal=true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            const item = response.item
            if (item){
              this.title=item.title
              this.time=item.average_time
              this.frequency=item.frequency
              this.prerequisite=item.prerequisite
              this.owner=item.owner
              this.text=item.text
              this.references=item.references
              this.is_references=item.is_references
              this.mechanic=item.mechanic
              this.allUsersMethodForedit(id)
              this.allUser.forEach((ele)=>{
                this.inserterId.push(ele.organizationposts_id)
              })
              this.allUserModal=false


            }




          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('organizationposts_id', JSON.stringify(this.inserterId))
      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('average_time', this.time)
      formdata.append('frequency', this.frequency)
      formdata.append('prerequisite', this.prerequisite)
      formdata.append('owner', this.owner)
      formdata.append('text', this.text)
      formdata.append('references', this.references)
      formdata.append('is_references', this.is_references)
      formdata.append('mechanic', this.mechanic)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.inserterId=''
            this.title=''
            this.inserterName=''
            this.editModal=false
            this.title= ''
            this.time= ''
            this.frequency= ''
            this.prerequisite= ''
            this.inserterId.length=0
            this.owner=''
            this.text= ''
            this.references= ''
            this.is_references= ''
            this.mechanic= ''



          })
          .catch();
    },
    saveItem() {
   if (this.inserterId.length===0){
        toast.error('سمت متولی اجباری است')
        return;

      }
      else if (!this.mechanic){
        toast.error(' مکانیزه است   اجباری است')
        return;

      }else if (!this.time){
        toast.error(' متوسط زمان اجرا   اجباری است')
        return;

      }
      else if (!this.frequency){
        toast.error('تواتر اجباری است')
        return;

      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('organizationposts_id', JSON.stringify(this.inserterId))
      formdata.append('users_id', JSON.stringify(this.inserterIdTwo))
      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('average_time', this.time)
      formdata.append('frequency', this.frequency)
      formdata.append('prerequisite', this.prerequisite)
      formdata.append('owner', this.owner)
      formdata.append('text', this.text)
      formdata.append('references', this.references)
      formdata.append('is_references', this.is_references)
      formdata.append('mechanic', this.mechanic)
      formdata.append('prerequisite', this.prerequisite)
      if (this.id_clone){
        formdata.append('id_clone', this.id_clone)

      }



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }

            this.addToSharedList()
            this.showItem()
            this.resetData()

          })
          .catch();

    },
    getInformations() {
      fetch(`${this.base_url}/processes/information_by_id/${this.id_route}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response) {
              if (response.item) {
                this.type = response.item.type

              }

            }

          }).catch((err) => {
      })
    },
    // *************************************************
    // *************************************************
    // *************************************************
    ...mapMutations(['setSharedList']),
    addToSharedList() {
      this.setSharedList(true);

    },
    filteredorganizationTwo() {
      return this.all_inserterTwo.filter(item => {
        return (
            item['name'].includes(this.search_inserterTwo) ||
            item['id'].toString().includes(this.search_inserterTwo)
        );
      });
    },

    showListInserter() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter.length = 0
            let uniqueNames = new Set();

            result['all'].forEach(item => {
              if (!uniqueNames.has(item.name)) {
                uniqueNames.add(item.name);
                this.all_inserter.push(item);
              }
            });





          })
          .catch();
      this.select_inserter = true
    },
    showItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/all/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.all_items.length=0
              response.all.forEach((item)=>{
                this.all_items.push(item)
              })

            }


          })
          .catch();

    },
    showListInserterTwo(){

      this.select_inserterTwo  = true

    },

    select_inserterMethod() {

      // اطمینان حاصل کنید inserterId یک آرایه از اعداد یا رشته‌ها است
      if (Array.isArray(this.inserterId)) {
        // متغیر برای نگهداری نتیجه
        let resultString = '';

        // بررسی هر عنصر در inserterId
        this.inserterId.forEach((id, index) => {
          // یافتن متن متناظر با id
          const matchingElement = this.all_inserter.find(ele => ele.id === id);

          // اگر یک متن متناظر پیدا شود، اضافه کردن به نتیجه
          if (matchingElement) {
            resultString += matchingElement.name;

            // اگر عنصر آخری نبود، خط تست را اضافه کنید
            if (index < this.inserterId.length - 1) {
              resultString += ' - ';
            }
          }
        });

        // نتیجه را در inserterName قرار دهید
        this.inserterName = resultString;

        // تغییر وضعیت select_inserter به false
        this.select_inserter = false;
      }
      this.select_inserter = false
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('id', JSON.stringify(this.inserterId))


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all_from_job`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.all_inserterTwo.length=0
              let uniqueNames = new Set();

              response['all'].forEach(item => {
                if (!uniqueNames.has(item.name)) {
                  uniqueNames.add(item.name);
                  this.all_inserterTwo.push(item);
                }
              });


            }


          })
          .catch();


    },


  },
  computed: {
    all() {
      return all
    },
    ...mapState(['statusInformation']),
    filteredorganization() {
      return this.all_inserter.filter(item => {
        return (
            item['name'].includes(this.search_inserter) ||
            item['id'].toString().includes(this.search_inserter)
        );
      });
    },
  },
  mounted() {
    this.getInformations()
    this.showItem()
  }

}

</script>
<style scoped>
.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: #D0E9FA57;
  color: var(--bs-table-striped-color);
}
</style>